import styled from 'styled-components';

const H2 = styled.h2`
  font-size: 38px;
  margin: 0;
`;

export default H2;
